import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { SolicitudesIngreso, ISolicitudesIngresoPagingRes, UseMutationsParams, AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put, remove } = erpApi();

///* tanSctack query

/* export const useGetSolicitudesIngreso = (params?: GetSolicitudesIngresosParams) => {
  return useQuery({
    queryKey: ['solicitud-Ingresos', ...Object.values(params || {})],
    queryFn: async () => {
      return await getSolicitudesIngresos(params);
    },
  });
}; */
export const useGetSolicitudesIngreso=(params?: GetSolicitudesIngresosParams)=>{
  return useQuery({
    queryKey:['solicitud-Ingreso', ...Object.values(params || [])],
    queryFn:async()=>{
      return await getSolicitudesIngresoByFilter(params);
    },
    retry:false,
    refetchOnWindowFocus:false,
  })
}

export const getSolicitudesIngresoByFilter = async(params?: GetSolicitudesIngresosParams)=>{
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<ISolicitudesIngresoPagingRes>(
    `${urlBackend}api/v1/solicitud-ingreso?${queryParams}`,
    true
  );
  return resp;
}

export const useGetSolicitudIngreso = (id: string) => {
  return useQuery({
    queryKey: ['solicitud-Ingresos', id],
    queryFn: async () => {
      return getSolicitudesIngreso(id);
    },
    enabled: !!id
  });
};
export const useCreateSolicitudesIngresos = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createSolicitudesIngreso,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-Ingresos'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'solicitud de Ingreso creada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateSolicitudesIngresos = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,

}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updateSolicitudesIngreso,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-Ingresos'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Solicitud de Ingreso actualizada correctamente',
          AlertSeverityEnum.success
        );

    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};
export const useRemoveSolicitudesIngresos = () => {
  const queryClient = useQueryClient();
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
  return useMutation({
    mutationFn: deleteSolicitudesIngreso,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-Ingreso'] });
    },
    onSettled: () => {
      setConfirmDialogIsOpen(false);
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};
///* axios
export interface GetSolicitudesIngresosParams extends Partial<SolicitudesIngreso>{
  page?: number;
  page_size?: number;
  nombre?: string;
  fecha_after?: string | null;
  fecha_before?: string| null;
  estado_solicitud?: string;
  estado_orden?: string;
  //numero_referencia?: string;
  ubicacion?:string;
};

export type CreateSolicitudesIngresosParams = Omit<SolicitudesIngreso, 'id_solicitudingreso'>;
export type UpdateSolicitudesIngresosParams = {
  id: string;
  data: CreateSolicitudesIngresosParams;
};


export const getSolicitudesIngresos = async (params?: GetSolicitudesIngresosParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<ISolicitudesIngresoPagingRes>(
    `${urlBackend}api/v1/solicitud-ingreso/?${queryParams}`,
    true
  );
};
export const getSolicitudesIngreso = async (id: string) => {
  try {
    return await get<SolicitudesIngreso>(`${urlBackend}api/v1/solicitud-ingreso/${id}/`, true);
  }
  catch (error) {
    return handleAxiosError(error);
  }
};

export const createSolicitudesIngreso = async (data: CreateSolicitudesIngresosParams) => {
  const res = await post<SolicitudesIngreso>(`${urlBackend}api/v1/solicitud-ingreso/`, data, true);
  return res;
};

export const updateSolicitudesIngreso = async ({ id, data }: UpdateSolicitudesIngresosParams) => {
  //const setAlert = useUiStore.getState().setAlert;
  const res = await put<SolicitudesIngreso>(`${urlBackend}api/v1/solicitud-ingreso/${id}/`, data, true);
  //setAlert(true, res.message, res.status);
  return res;
};

export const deleteSolicitudesIngreso = async ({ id }: UpdateSolicitudesIngresosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await remove<SolicitudesIngreso>(`${urlBackend}api/v1/solicitud-ingreso/${id}/`, true);
  setAlert(true, res.message, res.status);
  return res;
};